import { formatWeight } from 'src/utils'

export const scrollToTop = () => {
  const container = document.getElementById('main-container')
  if (container) {
    container.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

export const parseWeight = (value?: number | string) => {
  if (value === undefined || value === null) return ''

  const stringValue = String(value).replace('.', ',')
  return formatWeight(stringValue)
}
